<template>
    <div v-if="display" class="d-print-block" :class="{ 'd-none': hide }">
        <img :src="enterprise.logo" :alt="enterprise.name" class="img img-fluid" />
        <slot></slot>
    </div>
</template>

<script>
// Defaults
import axios from "axios";

// Start
export default {
    name: "EnterpriseLogoDisplay",
    mixins: [],
    components: {},
    props: {
        overrideDisplay: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            // Errors
            errors: [],

            // Displayers
            display: false,
            hide: true,

            // Group management
            enterprise: {},
        };
    },
    methods: {
        getEntepriseLogo() {
            // Check if we're actually an enterprise client
            if (this.isEnterprise) {
                axios
                    .get("enterprise/logo")
                    .then((response) => {
                        // Make pretty
                        var data = response.data;

                        // Check status
                        if (data.status == "OK") {
                            this.display = true;
                            this.enterprise = data.data;
                            this.enterprise.logo =
                                "https://hashtastic.eu/enterprise/logos/" +
                                this.enterprise.location;

                            // Check if we have an override
                            if (this.overrideDisplay) {
                                this.hide = false;
                            }
                        }
                    })
                    .catch((error) => {})
                    .finally(() => {});
            }
        },
    },

    computed: {
        isEnterprise() {
            return this.$store.getters["auth/isEnterprise"];
        },
    },

    mounted() {
        this.getEntepriseLogo();
    },
};
</script>
